var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "featureAccessModal",
      "centered": "",
      "size": "md",
      "close-on-backdrop": "",
      "hide-footer": "",
      "hide-header-close": ""
    },
    on: {
      "shown": _vm.handleModalShown
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "feature-access-header"
        }, [_c('div', {
          staticClass: "text-center"
        }, [_c('h4', [_vm._v("Feature Access")])])])];
      },
      proxy: true
    }])
  }, [_c('b-button', {
    staticClass: "btn-container",
    attrs: {
      "variant": "close-btn"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })]), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "feature-access-form"
  }, [_c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "form-group mb-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Email:")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.email
    }
  })]), _c('div', {
    staticClass: "form-group mb-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Select Feature:")]), _c('div', {
    staticClass: "checkbox-group feature-item"
  }, _vm._l(_vm.featureAccessCategories, function (feature) {
    return _c('div', {
      key: feature.id,
      staticClass: "custom-checkbox p-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.selectedFeatures,
        expression: "selectedFeatures"
      }],
      attrs: {
        "type": "checkbox",
        "id": "feature-".concat(feature.id)
      },
      domProps: {
        "value": feature.id,
        "checked": Array.isArray(_vm.selectedFeatures) ? _vm._i(_vm.selectedFeatures, feature.id) > -1 : _vm.selectedFeatures
      },
      on: {
        "change": function change($event) {
          var $$a = _vm.selectedFeatures,
              $$el = $event.target,
              $$c = $$el.checked ? true : false;

          if (Array.isArray($$a)) {
            var $$v = feature.id,
                $$i = _vm._i($$a, $$v);

            if ($$el.checked) {
              $$i < 0 && (_vm.selectedFeatures = $$a.concat([$$v]));
            } else {
              $$i > -1 && (_vm.selectedFeatures = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.selectedFeatures = $$c;
          }
        }
      }
    }), _c('label', {
      staticClass: "custom-label",
      attrs: {
        "for": "feature-".concat(feature.id)
      }
    }, [_vm._v(" " + _vm._s(feature.name) + " ")]), feature.description ? _c('span', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "title": feature.description
      }
    }, [_c('i', {
      staticClass: "fas fa-info-circle",
      staticStyle: {
        "cursor": "pointer",
        "margin-left": "10px",
        "color": "#007bff"
      }
    })]) : _vm._e()]);
  }), 0), _c('p', {
    staticClass: "text-info mt-4"
  }, [_c('strong', [_vm._v("Note:")]), _vm._v(" By selecting the feature(s), the access will be provided to the rep admin. ")])]), _c('div', {
    staticClass: "form-group text-center mb-3 mt-3"
  }, [_c('b-button', {
    staticClass: "univ-btn px-4 py-2",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Apply ")])], 1)])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }